import {createSlice} from '@reduxjs/toolkit'
import Sheet from "../../utils/sheet";
import SheetTemplate from "../../utils/sheetTemplate";

const activeSheet = createSlice({
    name: 'activeSheet',
    initialState: {
        sheet: new Sheet({}, {isStartingSheet: true}, 1.0, new SheetTemplate({height: 12, width: 18, }, 0), ''),
    },
    reducers: {
        setActiveSheet: (state, action) => {
            state.sheet = action.payload

            window.activeSheet = action.payload;

            window.activeSheetId = state.sheet.id;

        },
        setActiveSheetSize: (state, action) => {
            let tempSheet = {...state.sheet};
            tempSheet.size = action.payload.size
            // state.sheet = tempSheet

            window.activeSheet = tempSheet;

            window.activeSheetId = tempSheet.id;

        }

    }
});

export const {setActiveSheet,setActiveSheetSize} = activeSheet.actions;
export default activeSheet.reducer;
